import React from 'react';
import H2 from 'components/deprecated/legacyElements/H2';
import Body from 'components/componentLibrary/typography/Body';
import Headline from 'components/componentLibrary/typography/Headline';
import { track, analyticsEvents, eventCategories } from 'util/analytics';

import styles from './style.module.scss';

const click = () => {
  track(analyticsEvents.view_case_study, {
    category: eventCategories.homepage,
    label: 'Ollie',
  });
};

const TestimonialSection = () => (
  <section className="inset">
    <H2>This can be your future office</H2>
    <div className={styles.testimonialContainer}>
      <div className={styles.testimonialContent}>
        <Headline className={styles.testimonialQuotation}>
          SquareFoot was able to make a complex process much easier.
        </Headline>
        <Body className={styles.testimonialTestifier}>
          <strong>Yashoda Clark,</strong> VP of Strategy & Finance, Ollie
        </Body>
        {/* eslint-disable-next-line react/jsx-no-target-blank */}
        <a
          onClick={click}
          target="_blank"
          className={styles.ollieTestimonialLink}
          href="https://www.squarefoot.com/case-study/ollie/"
        >
          Case Study
        </a>
      </div>
      <picture>
        <source type="image/webp" srcSet={require('./ollie_office.webp')} />
        <img
          alt="An office lounge area with long leather couch, coffee table, and kitchen in the background"
          loading="lazy"
          src={require('./ollie_office.jpg')}
          className={styles.testimonialImage}
        />
      </picture>
    </div>

    <ul className={styles.testimonialLogos}>
      <li>
        <img
          loading="lazy"
          src={require('./clients/casper.png')}
          alt="Casper"
        />
      </li>
      <li>
        <img
          loading="lazy"
          src={require('./clients/breather.png')}
          alt="Breather"
        />
      </li>
      <li>
        <img
          loading="lazy"
          src={require('./clients/greatist.png')}
          alt="Greatist"
        />
      </li>
      <li>
        <img
          loading="lazy"
          src={require('./clients/instacart.png')}
          alt="Instacart"
        />
      </li>
      <li>
        <img
          loading="lazy"
          src={require('./clients/bodylabs.png')}
          alt="Body Labs"
        />
      </li>
      <li>
        <img loading="lazy" src={require('./clients/ollie.png')} alt="Ollie" />
      </li>
    </ul>
  </section>
);

export default TestimonialSection;
